import React from 'react';
import { QuickDateType } from '../hooks/useDateSelection';

interface DashboardHeaderProps {
  isLoading: boolean;
  dataSource: 'api' | 'empty';
  error: string | null;
  startDate: Date;
  endDate: Date;
  onQuickDateSelect: (type: QuickDateType) => Promise<void>;
  onOpenDatePicker: () => void;
  onRefresh: () => Promise<void>;
}

// 빠른 날짜 선택 버튼 설정
export const quickDateButtons = [
  { key: 'today', label: '오늘' },
  { key: 'week', label: '7일' },
  { key: 'thisMonth', label: '이번달' },
];

// 요약 카드 설정
export const summaryCards = [
  {
    key: 'totalProduction',
    label: '총 생산량',
    unit: '개',
    color: 'text-blue-600',
    bgColor: 'bg-blue-50'
  },
  {
    key: 'totalDefects',
    label: '총 불량',
    unit: '개',
    color: 'text-red-500',
    bgColor: 'bg-red-50'
  },
  {
    key: 'defectRate',
    label: '불량률',
    unit: '',
    color: 'text-orange-500',
    bgColor: 'bg-orange-50'
  },
  {
    key: 'kpiSendCount',
    label: 'KPI전송량',
    unit: '건',
    color: 'text-green-500',
    bgColor: 'bg-green-50'
  }
];

export const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  isLoading,
  dataSource,
  error,
  startDate,
  endDate,
  onQuickDateSelect,
  onOpenDatePicker,
  onRefresh
}) => {
  return (
    <div className="flex justify-between items-center">
      <h1 className="text-2xl font-bold">
        📊 실시간 생산실적 현황 
        {error && <span className="text-red-500 text-sm ml-2">({error})</span>}
      </h1>
      <div className="flex gap-2 items-center flex-wrap">
        {/* 현재 선택된 날짜 범위 표시 */}
        <div className="text-sm text-gray-600 bg-gray-100 px-3 py-1 rounded">
          {startDate.toLocaleDateString('ko-KR')} ~ {endDate.toLocaleDateString('ko-KR')}
        </div>
        
        {/* 빠른 날짜 선택 버튼들 */}
        <div className="flex gap-1">
          {quickDateButtons.map((button) => (
            <button 
              key={button.key}
              onClick={() => onQuickDateSelect(button.key as QuickDateType)}
              disabled={isLoading}
              className="px-2 py-1 text-xs bg-gray-200 text-gray-700 rounded hover:bg-gray-300 disabled:opacity-50"
            >
              {button.label}
            </button>
          ))}
        </div>
        
        <button 
          onClick={onOpenDatePicker}
          className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
        >
          📅 상세선택
        </button>
      </div>
    </div>
  );
}; 